import { Transfer_Status } from "gen/txn/models_pb"
import { useEnumFilter } from "shared-ts/hooks/useFilter"

import { useWebFilter, UseWebFilterProps } from "./useWebFilter"

const labelMap: Record<Transfer_Status, string> = {
  [Transfer_Status.UNDEFINED]: "Undefined",
  [Transfer_Status.CREATED]: "Created",
  [Transfer_Status.SENT]: "Sent",
  [Transfer_Status.RECEIVED]: "Received",
  [Transfer_Status.VOIDED]: "Voided",
  [Transfer_Status.REQUESTED]: "Requested",
}

export const useTransferStatusFilter = ({
  persistInUrl = true,
  initialSelectedOptions = [],
}: Partial<
  Pick<UseWebFilterProps<unknown>, "persistInUrl" | "initialSelectedOptions">
> = {}) =>
  useEnumFilter({
    key: "transferStatus",
    label: "Transfer Status",
    enumeration: Transfer_Status,
    labelExtractor: (v: Transfer_Status): string => {
      return labelMap[v]
    },
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      }),
  })
